import React, { Component } from 'react'
import styled from 'styled-components'

const CardWrapper = styled.div`
  border-radius: ${props => (props.boxRadius ? props.boxRadius : '6px')};
  box-shadow: ${props => (props.boxShadow ? props.boxShadow : '0 3px 14px 0 rgba(0, 0, 0, 0.1)')};
  padding: ${props => (props.padding ? props.padding : '24px')};
  margin: ${props => (props.margin ? props.margin : '0')};
  width: ${props => (props.width ? props.width : '100%')};
  height: ${props => (props.height ? props.height : 'auto')};
  background: ${props => (props.selectedChip ? '#078489' : '#fbf8f1')};
  background-color: ${props => (props.bgColor ? props.bgColor : '#fbf8f1')};
  filter: ${props => (props.filter ? props.filter : 'none')};
  -webkit-transition: background-color 0.1s ease-in;
  -moz-transition: background-color 0.1s ease-in;
  -o-transition: background-color 0.1s ease-in;
  transition: background-color 0.1s ease-in;

  ${props =>
    props.selectedChip &&
    `
    background-color: #078489;
    & p{
      color: #fff;
    }
  `} &:focus {
    outline: none !important;
  }
  ${props =>
    props.forSlick &&
    `
  display: inline-flex !important;
  flex-direction: column !important;
  justify-content: space-between !important;

  `};
  ${props =>
    props.circular &&
    `
    
  border-radius: 100px;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.16);
  background: ${props => (props.selected ? '#078489' : '#fbf8f1')};
  padding: ${props => (props.padding ? props.padding : '8px 16px')};
  width: auto;
  margin: 0 14px 14px 0;
  cursor: pointer;
  & p{
    text-align: center;
    &:first-child{
      color:${props => (props.selected ? '#fff' : '#124b5f')};
      line-height: 1.56;
    }
    &:last-child{
      color:${props => (props.selected ? '#fff' : '#078489')};
      font-weight: 300;
      line-height: 1.29;
    }
  }
  `};
  ${props =>
    props.bordered &&
    `
  border-radius: 100px;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.16);
  border: 1px solid #124b5f !important;
  padding: 16px;
  width: auto;
  margin: 0 14px 14px 0;
  cursor: pointer;
  `};
  position: ${props => (props.position ? props.position : 'relative')} !important;
  overflow-y: ${props => (props.overflowY ? props.overflowY : 'initial')};
  z-index: 99999;
  ${props =>
    props.activeCard &&
    `
    border: 1px solid #078489;
      .shape {
        background: #078489 !important;
        & > p {
          color: #fff !important;
        } 
  `};
  ${props =>
    props.activeValueCard &&
    `
    background: #078489 !important;
        & p {
          color: #fff !important;
        } 
    & svg * {
      fill: #fff !important;
    }
  `};
`
class Card extends Component {
  state = {}
  render() {
    const {
      children,
      circular,
      activeCard,
      selectedChip,
      forSlick,
      bordered,
      position,
      selected,
      padding,
      margin,
      ...props
    } = this.props
    return (
      <CardWrapper
        forSlick={forSlick}
        selected={selected}
        selectedChip={selectedChip}
        bordered={bordered}
        padding={padding}
        margin={margin}
        circular={circular}
        activeCard={activeCard}
        position={position}
        {...props}>
        {children}
      </CardWrapper>
    )
  }
}

export default Card



// WEBPACK FOOTER //
// ./src/components/Card.js